import { hazmat_override_source } from '@/@types/generated'
import { register } from './enum'

const HazmatOverrideSourceLabels: Record<hazmat_override_source, string> = {
  [hazmat_override_source.CARRIER]: 'Carrier',
  [hazmat_override_source.STAFF]: 'TxDMV staff',
  [hazmat_override_source.SYSTEM]: 'System',
}

register<hazmat_override_source>(hazmat_override_source, (v) => {
  if (!v) return '—'
  return HazmatOverrideSourceLabels[v]
})
